import React from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import { state } from 'app/pwa/app.cerebral';
import PageContainer from '../common/PageContainer';

import Success from './Success';
import Form from './Form';

const deps = {
  success: state.account.newPasswordSetSuccessfully,
};

export function Password({
  success,
}: typeof deps & ConnectedProps): React.ReactElement {
  return (
    <PageContainer tab={'password'}>
      {success ? <Success /> : <Form />}
    </PageContainer>
  );
}

export default connect(deps, Password);
